import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postComment } from '../api/comments';
import type { PostCommentPayload, Comment } from '../api/comments';

interface UsePostCommentOptions {
  onSuccess?: (data: Comment) => void;
  onError?: (error: Error) => void;
}

export const usePostComment = (options: UsePostCommentOptions = {}) => {
  const queryClient = useQueryClient();

  return useMutation<Comment, Error, PostCommentPayload>({ 
    mutationFn: postComment,
    onSuccess: (data) => {
      // When a comment is posted, invalidate queries for that book's comments
      // to refetch and show the new comment.
      queryClient.invalidateQueries({ queryKey: ['comments', data.book_id] });
      
      // Also invalidate infinite comments query
      queryClient.invalidateQueries({ queryKey: ['commentsInfinite', data.book_id] });
      
      // Also invalidate the comment stats for the book
      queryClient.invalidateQueries({ queryKey: ['commentStats', data.book_id] });

      if (options.onSuccess) {
        options.onSuccess(data);
      }
    },
    onError: (error) => {
      if (options.onError) {
        options.onError(error);
      }
    },
  });
};
